import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { KYCUPDATEVIEWLABELS, KYCUPDATEVIEWMESSAGES } from '../../_constants/constants';
import { DEFAULT_OPCO, SPAIN, ITALY, GERMANY, UK } from '../../_constants/config';
import { KycUpdateData, PersonDetails } from '../../_models/data.structures';
import { CustomerService } from '../../_services/customer.service';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { NotificationDialogComponent } from './../../notification/notification.dialog.component';

import { TranslatePipe } from '../../shared/translate/translate.pipe';
export interface KycUpdateModel {
  title: string;
  personDetails: PersonDetails;
  kycUpdateData: KycUpdateData;
  subValue: string;
  opcoValue: string;
  customerService: CustomerService;
}

@Component({
  templateUrl: './kyc.update.dialog.component.html',
  providers: [TranslatePipe]
})

export class KycUpdateDialogComponent extends DialogComponent<KycUpdateModel, string> implements KycUpdateModel{

  title: string;
  kycUpdateData: KycUpdateData;
  personDetails: PersonDetails;
  kycupdateviewlabels = KYCUPDATEVIEWLABELS;
  kycupdateviewmessages = KYCUPDATEVIEWMESSAGES;
  statusRange = [];
  statusTranslated = [];
  idTypeTranslated = [];
  documentTypeRange = [];
  subValue: string;
  opcoValue: string;
  customerService: CustomerService;
  userconfigfields = DEFAULT_OPCO;
  personalTypeRange = [];

  requiredErrorMsg: string = "";


  monthsTranslated: any = [];
  issueDay: any = "";
  issueMonth: any = "0";
  issueYear: any = "";
  issueDateError: boolean = false;
  issueDateErrMsg = "";

  expireDay: any = "";
  expireMonth: any = "0";
  expireYear: any = "";
  expiryDateError: boolean = false;
  expiryDateErrMsg = "";

  public model: any = null;

  public model1: any = null;

  objectKeys = Object.keys;
  jsonparse = JSON.parse;


  isTypeErr: boolean = false;
  isStatusErr: boolean = false;
  isURLErr: boolean = false;

  constructor(private ds: DialogService, private translatePipe: TranslatePipe) {
    super(ds);
    for (let i = 0; i < this.kycupdateviewlabels.STATUS_OPTIONS_REAL_VALUES.length; i++) {
      this.statusRange.push(i);
    }

    this.statusTranslated = this.translatePipe.transform("STATUS_OPTIONS_SHOWN_VALUES",'KYCUPDATEVIEWLABELS');  
    this.requiredErrorMsg = this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR');  


    this.issueDateError = false;
    this.issueDateErrMsg = "";

    this.expiryDateError = false;
    this.expiryDateErrMsg = "";
  }

  setCustomValidity(event) {

    if (event.target.value === '') {
      event.target.setCustomValidity(this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'));
    }
    else {
      event.target.setCustomValidity('');
    }

    return true;
  }

  setCustomValidityBlank(event) {
    event.target.setCustomValidity('');
  }

  mouseHover(event) {

    event.target.setAttribute("title", "");
    
    // if (event.target.value == "") {
    //   event.target.setAttribute("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'))
    // }
    // else {
    //   event.target.setAttribute("title", "")
    // }
  }

  private myDatePickerOptionsissue: IMyDpOptions = {
      dateFormat: 'yyyy-mm-dd',
      height: '34px',
      width: '100%',
      inline: false,
      editableDateField: false,
      disableSince: {year: (new Date()).getFullYear(), month: (new Date()).getMonth()+1, day: (new Date()).getDate()+1}
  };

  private myDatePickerOptionsexp: IMyDpOptions = {
      dateFormat: 'yyyy-mm-dd',
      height: '34px',
      width: '100%',
      inline: false,
      editableDateField: false,
      disableUntil: {year: (new Date()).getFullYear(), month: (new Date()).getMonth()+1, day: (new Date()).getDate()-1}
  };


  keyDownEvent(e) {

    if (e.which === 32)
      e.preventDefault();    
  }
 

  apply(formData: any) {
    let valid = true;
    var data = this.kycUpdateData;
    var fieldConfig = this.userconfigfields;


    this.isTypeErr = false;
    this.isStatusErr = false;
    this.isURLErr = false;


    if ((this.kycUpdateData.status !== null) && (this.kycUpdateData.status.trim() !== "") && (this.kycUpdateData.status !== undefined)) {
      if (!this.statusTranslated.hasOwnProperty(this.kycUpdateData.status)) {

        this.isStatusErr = true;
        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_STATUS_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
    }

    if (Object.getOwnPropertyNames(this.kycUpdateData.personal_id).length !== 0) {
      if ( (this.kycUpdateData.personal_id.id_type !== null || this.kycUpdateData.personal_id.id_type !== undefined || this.kycUpdateData.personal_id.id_type.trim() !== "") ) {
        if (!this.idTypeTranslated.hasOwnProperty(this.kycUpdateData.personal_id.id_type)) {
          this.isTypeErr = true;
          // this.ds.addDialog(NotificationDialogComponent, {
          //   success: false,
          //   message: this.translatePipe.transform("INVALID_IDTYPE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
          // });
          return;
        }
      }
    }


    //if(fieldConfig.kyc_personal_id_issue_date !== "false" && data.personal_id.issue_date === ""){
    if (fieldConfig.kyc_personal_id_issue_date !== "false" && (this.issueYear === "" || this.issueDay === "" || this.issueMonth === "0")) {

      this.issueDateError = true;
      this.issueDateErrMsg = this.translatePipe.transform("KYC_ISSUE_DATE_REQUIRED", 'KYCUPDATEVIEWMESSAGES');

      // this.ds.addDialog(NotificationDialogComponent, {
      //   success: false,
      //   message: this.translatePipe.transform("KYC_ISSUE_DATE_REQUIRED",'KYCUPDATEVIEWMESSAGES')
      // });
      return;
    } else if (fieldConfig.kyc_personal_id_expiration_date !== "false" && (this.expireYear === "" || this.expireDay === "" || this.expireMonth === "0")) {

      this.expiryDateError = true;
      this.expiryDateErrMsg = this.translatePipe.transform("KYC_EXPIRATION_DATE_REQUIRED", 'KYCUPDATEVIEWMESSAGES');


      // this.ds.addDialog(NotificationDialogComponent, {
      //   success: false,
      //   message: this.translatePipe.transform("KYC_EXPIRATION_DATE_REQUIRED",'KYCUPDATEVIEWMESSAGES')
      // });
      return;
    }else {

      if (this.issueYear != "" && this.issueDay != "") {

        if (this.issueMonth == "0") {

          this.issueDateError = true;
          this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

          valid = false;

          // this.ds.addDialog(NotificationDialogComponent, {
          //   success: false,
          //   message: this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
          // });
          return;
        }
        else if (parseInt(this.issueYear) == 0 || parseInt(this.issueDay) == 0 || this.isNumeric(this.issueYear) === false || this.isNumeric(this.issueDay) === false) {

          valid = false;

          this.issueDateError = true;
          this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

          // this.ds.addDialog(NotificationDialogComponent, {
          //   success: false,
          //   message: this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
          // });
          return;
        }
        else {
         

          let issueDate = new Date(this.issueYear + "/" + this.issueMonth + "/" + this.issueDay);
          let currentDate = new Date();
        
          
 if(issueDate<new Date(this.personDetails.birthdate) || issueDate.toString()==="Invalid Date"){
            valid = false;

            this.issueDateError = true;
            this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
             return ;
          }
       
if (issueDate > currentDate) {

            valid = false;

            this.issueDateError = true;
            this.issueDateErrMsg = this.translatePipe.transform("ISSUE_DATE_IS_IN_FUTURE", 'CLIENT_SIDE_VALIDATION_ERROR');

            // this.ds.addDialog(NotificationDialogComponent, {
            //   success: false,
            //   message: this.translatePipe.transform("ISSUE_DATE_IS_IN_FUTURE", 'CLIENT_SIDE_VALIDATION_ERROR')
            // });
            return;
          }

          // if (parseInt(this.issueMonth) <= 9 && this.issueMonth.length ==1) {
          //   this.issueMonth = "0" + this.issueMonth;
          // }
          // this.kycUpdateData.personal_id.issue_date = this.issueYear + "-" + this.issueMonth + "-" + this.issueDay;
        }
      }
      else if (this.issueMonth != "0" && (this.issueYear == "" || this.issueDay == "")) {

        valid = false;

        this.issueDateError = true;
        this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else if (this.issueDay != "" && (this.issueMonth == "0" || this.issueYear == "")) {

        valid = false;

        this.issueDateError = true;
        this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else if (this.issueYear != "" && (this.issueMonth == "0" || this.issueDay == "")) {

        valid = false;

        this.issueDateError = true;
        this.issueDateErrMsg = this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_ISSUE_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else {
        this.kycUpdateData.personal_id.issue_date = "";
      }




      if (this.expireYear != "" && this.expireDay != "") {

        if (this.expireMonth == "0") {

          valid = false;

          this.expiryDateError = true;
          this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

          // this.ds.addDialog(NotificationDialogComponent, {
          //   success: false,
          //   message: this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
          // });
          return;
        }
    else if (parseInt(this.expireYear) == 0 || parseInt(this.expireDay) == 0 || this.isNumeric(this.expireYear) === false || this.isNumeric(this.expireDay) === false) {

          valid = false;

          this.expiryDateError = true;
          this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

          // this.ds.addDialog(NotificationDialogComponent, {
          //   success: false,
          //   message: this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
          // });
          return;
        }
        else {

          let expirationDate = new Date(this.expireYear + "/" + this.expireMonth + "/" + this.expireDay);
          let currentDate = new Date();          
 if(expirationDate.toString()==="Invalid Date")
          {
            valid = false;

            this.expiryDateError = true;
            this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
             return ;
          }
          if (expirationDate < currentDate || this.expireYear.length <=3) {

            valid = false;

            this.expiryDateError = true;
            this.expiryDateErrMsg = this.translatePipe.transform("PAST_EXPIRATION_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

            // this.ds.addDialog(NotificationDialogComponent, {
            //   success: false,
            //   message: this.translatePipe.transform("PAST_EXPIRATION_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
            // });
            return;
          }

          // if (parseInt(this.expireMonth) <= 9 && this.expireMonth.length == 1) {
          //   this.expireMonth = "0" + this.expireMonth;
          // }
          // this.kycUpdateData.personal_id.expiration_date = this.expireYear + "-" + this.expireMonth + "-" + this.expireDay;
        }
      }
      else if (this.expireMonth != "0" && (this.expireYear == "" || this.expireDay == "")) {

        valid = false;

        this.expiryDateError = true;
        this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else if (this.expireDay != "" && (this.expireMonth == "0" || this.expireYear == "")) {

        valid = false;

        this.expiryDateError = true;
        this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else if (this.expireYear != "" && (this.expireMonth == "0" || this.expireDay == "")) {

        valid = false;

        this.expiryDateError = true;
        this.expiryDateErrMsg = this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');

        // this.ds.addDialog(NotificationDialogComponent, {
        //   success: false,
        //   message: this.translatePipe.transform("INVALID_EXPIRY_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
        // });
        return;
      }
      else {
        this.kycUpdateData.personal_id.expiration_date = "";
      }



    if (fieldConfig.kyc_fiscal_code === "true" && (formData.form.controls['fiscal_code_Input'] !== undefined) && ((this.kycUpdateData.fiscal_code === null) || (this.kycUpdateData.fiscal_code.trim() == "") || (this.kycUpdateData.fiscal_code === undefined))) {

          formData.form.controls['fiscal_code_Input'].markAsDirty();
          formData.form.controls['fiscal_code_Input'].markAsTouched();
          formData.form.controls['fiscal_code_Input'].setErrors({ 'required': true });
          return;
           
    }


    if (fieldConfig.kyc_nationality === "true" && (formData.form.controls['nationalityInput'] !== undefined) && ((this.kycUpdateData.nationality === null) || (this.kycUpdateData.nationality.trim() == "") || (this.kycUpdateData.nationality === undefined))) {

      formData.form.controls['nationalityInput'].markAsDirty();
      formData.form.controls['nationalityInput'].markAsTouched();
      formData.form.controls['nationalityInput'].setErrors({ 'required': true });
      return;
    }


    if (fieldConfig.kyc_personal_id_id_number === "true" && (formData.form.controls['pid_number_Input'] !== undefined) && ((this.kycUpdateData.personal_id.id_number === null) || (this.kycUpdateData.personal_id.id_number.trim() == "") || (this.kycUpdateData.personal_id.id_number === undefined))) {

      formData.form.controls['pid_number_Input'].markAsDirty();
      formData.form.controls['pid_number_Input'].markAsTouched();
      formData.form.controls['pid_number_Input'].setErrors({ 'required': true });
      return;
    }

      if (this.kycUpdateData.external_reference_link && this.kycUpdateData.external_reference_link !== "") {

        if ((/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/).test(this.kycUpdateData.external_reference_link) === false){
          this.isURLErr = true;
          return;
        }

      }



    

      if(valid){

        if (this.issueYear != "" && this.issueDay != "" && this.issueMonth!="0"){

          if (parseInt(this.issueMonth) <= 9 && this.issueMonth.length == 1) {
            this.issueMonth = "0" + this.issueMonth;
          }
          this.kycUpdateData.personal_id.issue_date = this.issueYear + "-" + this.issueMonth + "-" + this.issueDay;
        }

        if (this.expireYear != "" && this.expireDay != "" && this.expireMonth != "0") {

          if (parseInt(this.expireMonth) <= 9 && this.expireMonth.length == 1) {
            this.expireMonth = "0" + this.expireMonth;
          }
          this.kycUpdateData.personal_id.expiration_date = this.expireYear + "-" + this.expireMonth + "-" + this.expireDay;
        }       

      }

      this.customerService.saveKYCChange(this.subValue, this.opcoValue, this.kycUpdateData, this.ds);
      this.close();
    }
  }


  onlyNumber(e) {
    e = (e) ? e : window.event;
    var charCode = (e.which) ? e.which : e.keyCode;

    if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
    if (e.target.name == "issue_day" || e.target.name == "issue_year"){
      this.issueDateError = false;
      this.issueDateErrMsg = "";
    }
    else if (e.target.name == "expire_day" || e.target.name == "expire_year") {
      this.expiryDateError = false;
      this.expiryDateErrMsg = "";
    }
   
  }

  urlChange(e){
    this.isURLErr = false;
  }


  monthChange(e){
    if (e.target.name == "issue_month" || e.target.name == "issue_month") {
      this.issueDateError = false;
      this.issueDateErrMsg = "";
    }
    else if (e.target.name == "expire_month" || e.target.name == "expire_month") {
      this.expiryDateError = false;
      this.expiryDateErrMsg = "";
    }
  }

  isNumeric(str) {
    var pattern = /^\d+$/;
    return pattern.test(str);
  }

  onBlurDayIssue(evt) {
    let val = evt.target.value;

    if (parseInt(val) >= 1 && parseInt(val) <= 9) {
      if (val.length == 1) {
        this.issueDay = "0" + this.issueDay;
      }
    }
  }


  onBlurDayExpiry(evt) {
    let val = evt.target.value;

    if (parseInt(val) >= 1 && parseInt(val) <= 9) {
      if (val.length == 1) {
        this.expireDay = "0" + this.expireDay;
      }
    }
  }

  ngOnInit(): void {


    this.monthsTranslated = this.translatePipe.transform("CALENDAR_MONTHS", 'CALENDAR_SELECT_VALUES');
console.log(this.personDetails,'per')
        var opco = "";
        if(this.opcoValue === "nv"){
            opco = this.personDetails["country"] ? this.personDetails["country"].toLowerCase() : ""; //this.personDetails.address.country;
        }else{
          opco = this.opcoValue;
        }

        if( opco === 'es' ){
            this.userconfigfields = SPAIN;
        }
        
        else if( opco === 'de' ){
            this.userconfigfields = GERMANY;
        }
        
        else if( opco === 'it' ){
            this.userconfigfields = ITALY;
        }
        
        else if( opco === 'gb' ){
            this.userconfigfields = UK;
        }

        for (let i = 0; i < this.userconfigfields.kyc_pid_type_name.length; i++) {
          this.personalTypeRange.push(i);
        }

        var dt = this.kycUpdateData.personal_id.issue_date;
        if(dt){
          var a = dt.split("-");
          this.model = {date: {year: parseInt(a[0]), month: parseInt(a[1]), day: parseInt(a[2])}};

          this.issueDay = a[2];
          this.issueMonth = a[1];
          this.issueYear = a[0];

          if (parseInt(this.issueMonth) >= 1 && parseInt(this.issueMonth) <= 9) {
            this.issueMonth = this.issueMonth.substring(1);
          }
        }
        var dt1 = this.kycUpdateData.personal_id.expiration_date;
        if(dt1){
          var a1 = dt1.split("-");
          this.model1 = {date: {year: parseInt(a1[0]), month: parseInt(a1[1]), day: parseInt(a1[2])}};


          this.expireDay = a1[2];
          this.expireMonth = a1[1];
          this.expireYear = a1[0];

          if (parseInt(this.expireMonth) >= 1 && parseInt(this.expireMonth) <= 9) {
            this.expireMonth = this.expireMonth.substring(1);
          }

          
        }


        this.idTypeTranslated = this.translatePipe.transform("ID_TYPE_SHOWN_VALUES",'ID_TYPE');

        for (let key of Object.keys(this.idTypeTranslated)) {          
          if(this.userconfigfields.kyc_pid_type_value.indexOf(key) < 0) {
            delete this.idTypeTranslated[key];                        
          }
          //IE11 does not support includes----
          // if(!this.userconfigfields.kyc_pid_type_value.includes(key)){            
          //   delete this.idTypeTranslated[key];
          // }          
        }
  }

  onIssueInputFieldChanged(event: IMyInputFieldChanged) {
      //console.log('onInputFieldChanged(): Value: ', event.value, ' - dateFormat: ', event.dateFormat, ' - valid: ', event.valid);
      this.kycUpdateData.personal_id.issue_date = event.value;
  }

  onExpInputFieldChanged(event: IMyInputFieldChanged) {
      //console.log('onInputFieldChanged(): Value: ', event.value, ' - dateFormat: ', event.dateFormat, ' - valid: ', event.valid);
      this.kycUpdateData.personal_id.expiration_date = event.value;
  }

}



// WEBPACK FOOTER //
// ./src/app/details/kyc/kyc.update.dialog.component.ts